import styled from 'styled-components'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'

export const Sponsors = () => {
  return (
    <Container>
      <TextWidth>
        <Content>
        {/* <Separator /> */}
          <Label>Ce projet est le fruit d’une collaboration entre Tamedia, le service de médecine de premier recours et la direction de la communication des HUG via la plateforme RAFAEL.</Label>
          <LogosContainer>
            <img
              alt='Logo des HUG'
              src={require('../../logos/hug.svg').default}
            />
            <div
              style={{
                height: '20px',
                width: 1,
                background: '#f1f2f3',
              }}
            />
            <img
              alt='Logo de la Fondation provée des HUG'
              src={require('../../logos/fondation-privee-des-hug.svg').default}
            />
            <div
              style={{
                height: '20px',
                width: 1,
                background: '#f1f2f3',
              }}
            />
            <img
              alt='Logo du site des HUG Rafael'
              src={require('../../logos/rafael.svg').default}
            />
          </LogosContainer>
          </Content>
      </TextWidth>
    </Container>
  )
}

const Separator = styled.div`
  height: 1px;
  background: ${({theme}) => theme.grayMain};
  width: 100%;
`

const Container = styled.div`
  font-family: var(--font-sans-serif);
  counter-reset: section;
  padding: 0;
  margin-bottom: 0px;
  margin-bottom: 20px;
`

const Content = styled.div`
  background: ${({ theme }) => theme.colorMode === 'dark' ? '#222222' : theme.grayLight};
  padding: 8px 20px;
`

const Label = styled.div`
  font-size: 1.2rem;
  line-height: 1.35;
  font-family: var(--font-sans-serif);
`

const LogosContainer = styled.div`
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  display: flex;

  img {
    max-height: 25px;
    mix-blend-mode: multiply;
  }

  img:first-child {
    margin-left: 0;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    img {
      height: 5vw;
      margin: 20px;
    }
  }

  @media ${device.tablet}, @media ${device.laptop} {
    img {
      height: 5vw;
      margin: 12px;
    }
  }
`

export default Sponsors
